import { Divider } from '@material-ui/core'
import React from 'react'
import { SectionLinks } from './SectionLinks'
import { tiers } from './tierUtils'

interface ClassesInterface {
  caretIconExpanded: string
}

interface TierLinksProps {
  tierType: string
  tierLinks: object
  classes: ClassesInterface
  country: string
  language: string
  productNumber?: string
  isBlueProduct?: boolean
  showDivider?: boolean
}
export const TierLinks: React.FC<TierLinksProps> = ({
  tierType,
  tierLinks,
  classes,
  country,
  language,
  productNumber,
  isBlueProduct,
  showDivider = false,
}) => {
  const links = Object.keys(tierLinks)
    .sort((a, b) => {
      return a < b ? -1 : 1
    })
    .map((section, index) => {
      return (
        <div key={`section-links-${section}-${index}`}>
          {index > 0 && showDivider && <Divider></Divider>}
          <SectionLinks
            message={tiers[tierType][section]}
            sectionLinks={tierLinks[section]}
            country={country}
            language={language}
            classes={classes}
            productNumber={productNumber}
            isBlueProduct={isBlueProduct}
          />
        </div>
      )
    })
  return <>{links}</>
}
